export const inspectorTools = {
  // consolidate into autocompletes
  NONE: "None",

  // consolidate into editable list
  NAVIGATION_CONFIGURATION: "NavigationConfiguration", // sortable, items not editable (trigger modal)
  TAB_PICKER: "TabPicker", // sortable, items not editable (trigger modal)

  // consolidated
  SIMPLE_INPUT: "SimpleInput",
  SCALE_CONTROL: "ScaleControl",
  SIMPLE_PICKER: "SimplePicker",
  ARROW_PICKER: "ArrowPicker",
  LIST_VIEW: "ListView",
  COLOR_PICKER: "ColorPicker",
  RICH_TEXT_INPUT: "RichTextInput",
  IMAGE_PICKER_V2: "ImagePickerV2",
  MEDIA_PICKER: "MediaPicker",
  ICON_PICKER: "IconPicker",
  RADIO_BAR: "RadioBar",
  VISIBLE_PICKER: "VisiblePicker",
  AUTOCOMPLETE: "AutoComplete",
  GRADIENT_PICKER: "GradientPicker",
  SPACING_PICKER: "SpacingPicker",
  CLIP_PATH: "ClipPath",
  FILTER_CONFIGURATOR: "FilterConfigurator",

  // toolsets
  WIDTH_HEIGHT_TOOL_SET: "WidthHeightToolSet",
  BUTTON_TOOL_SET: "ButtonToolSet",
  BUTTON_BORDERS_TOOL_SET: "ButtonBordersToolSet",
  CAROUSEL_TOOL_SET: "CarouselToolSet",
  POSITIONING_TOOL_SET: "PositioningToolSet",
  BASIC_TEXT_TOOL_SET: "BasicTextToolSet",
  ADVANCED_TEXT_TOOL_SET: "AdvancedTextToolSet",
  STYLED_TEXT_TOOL_SET: "StyledTextToolSet",
  PREFIX_SUFFIX_TOOL_SET: "PrefixSuffixToolSet",
  DISPLAY_ACTIONS_TOOL_SET: "DisplayActionsToolSet",
  GLOBAL_FEED_TOOL_SET: "GlobalFeedToolSet",
  FEED_COMPONENT_TOOL_SET: "FeedComponentToolSet",
  FEED_EMPTY_STATE_TOOL_SET: "FeedEmptyStateToolSet",
  FEED_SEPARATORS_TOOL_SET: "FeedSeparatorsToolSet",
  FEED_SEPARATORS_RULES: "FeedSeparatorsRules",
  FEED_FILTERS_TOOL_SET: "FeedFiltersToolSet",
  APP_FEED_COMPONENT_PICKER: "AppFeedComponentPicker",
  REFERENCED_COMPONENT_PICKER: "ReferencedComponentPicker",
  APP_ENTITY_PICKER: "AppEntityPicker",
  DROP_SELECTION_BINDINGS: "DropSelectionBindings",
  ANIMATIONS_TOOL_SET: "AnimationsToolSet",
  ANIMATIONS_EFFECTS_TOOL_SET: "AnimationsEffectsToolSet",
  ICON_TOOL_SET: "IconToolSet",
  VERTICAL_POSITION_TOOL_SET: "VerticalPositionToolSet",
  HORIZONTAL_POSITION_TOOL_SET: "HorizontalPositionToolSet",
  LAYOUT_POSITION_TOOL_SET: "LayoutPositionToolSet",
  APPEARANCE_TOOL_SET: "AppearanceToolSet",
  BACKGROUND_TOOL_SET: "BackgroundToolSet",
  IMAGE_TOOLSET: "ImageToolSet",
  VIDEO_TOOLSET: "VideoToolSet",
  ACTION_BUTTON_TOOL_SET: "ActionButtonToolSet",
  USER_MENU_TOOL_SET: "UserMenuToolSet",

  OPTION_GROUP: "OptionGroup",
  GROUPED_OPTIONS_TOOL_SET: "GroupedOptionsToolSet",

  // Nested tool rendered inside OptionGroup's settings modal when editing a
  // variable's default. Declared here so option-variables.js can reference it
  // by string instead of importing the .vue file directly — a direct import
  // back onto option-variables would re-create the tools → mixin →
  // DynamicElement → options → option-variables cycle the registry exists to
  // avoid.
  UPDATE_OPTION_VARIABLE: "UpdateOptionVariable",

  // unsure about this
  MODAL_PICKER: "ModalPicker",
  POSITION_DIRECTION_INPUT: "PositionDirectionInput",
  NEW_BORDER_PICKER: "NewBorderPicker",
  FONT_FAMILY_PICKER_V2: "FontFamilyPickerV2",
  CLICK_ACTION: "ClickAction",
  SHADOW_PICKER: "ShadowPicker",
  PROVIDES_CONTEXTS: "ProvidesContexts",
  PAGE_ACCESS: "PageAccess",
  COMPONENT_PROVIDES_CONTEXTS: "ComponentProvidesContexts",
  REQUIRED_CONTEXTS: "RequiredContexts",
  COMPONENT_CONTEXT_BINDINGS: "ComponentContextBindings",
  COMPLETION_COMPONENTS: "CompletionComponents",
};
